(function () {
  function nextLocalMidnight() {
    var n = new Date();
    var next = new Date(n);
    next.setHours(24, 0, 0, 0);
    return next.getTime();
  }

  var el = document.getElementById('advent-countdown');
  if (!el) return;

  function tick() {
    var diff = Math.max(0, nextLocalMidnight() - Date.now());
    var h = Math.floor(diff / 36e5);
    var m = Math.floor((diff % 36e5) / 6e4);
    var s = Math.floor((diff % 6e4) / 1000);
    el.textContent =
      String(h).padStart(2, '0') + ':' +
      String(m).padStart(2, '0') + ':' +
      String(s).padStart(2, '0');
  }

  tick();
  setInterval(tick, 1000);
})();
